import { fetchWithSupabaseAuth } from "./supabaseClient.js";

const SOLLIO_RULES_ENDPOINT = "/api/import/sollio/delivery-address-rules";

export class SollioDeliveryAddressApiError extends Error {
  constructor(message, { payload = null, status = 0 } = {}) {
    super(message);
    this.name = "SollioDeliveryAddressApiError";
    this.payload = payload;
    this.status = status;
  }
}

async function parseJson(response) {
  return response.json().catch(() => null);
}

function resolveErrorMessage(payload, fallback) {
  if (typeof payload?.detail === "string" && payload.detail.trim()) {
    return payload.detail.trim();
  }
  if (typeof payload?.message === "string" && payload.message.trim()) {
    return payload.message.trim();
  }
  return fallback;
}

async function requestJson(url, init, fallbackMessage) {
  const response = await fetchWithSupabaseAuth(url, {
    cache: "no-store",
    ...init,
  });
  const payload = await parseJson(response);
  if (!response.ok) {
    throw new SollioDeliveryAddressApiError(resolveErrorMessage(payload, fallbackMessage), {
      payload,
      status: response.status,
    });
  }
  return payload && typeof payload === "object" ? payload : {};
}

export async function fetchSollioDeliveryAddressRules({ fetchImpl, signal } = {}) {
  return requestJson(SOLLIO_RULES_ENDPOINT, { fetchImpl, signal }, "Impossible de charger les règles Sollio.");
}

export async function createSollioDeliveryAddressRule(payload, { fetchImpl, signal } = {}) {
  return requestJson(SOLLIO_RULES_ENDPOINT, {
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
		fetchImpl,
    method: "POST",
    signal,
  }, "Impossible de créer la règle Sollio.");
}

export async function updateSollioDeliveryAddressRule(ruleId, payload, { fetchImpl, signal } = {}) {
  return requestJson(`${SOLLIO_RULES_ENDPOINT}/${encodeURIComponent(ruleId)}`, {
    body: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
		fetchImpl,
    method: "PATCH",
    signal,
  }, "Impossible de modifier la règle Sollio.");
}

export async function deleteSollioDeliveryAddressRule(ruleId, { fetchImpl, signal } = {}) {
  return requestJson(`${SOLLIO_RULES_ENDPOINT}/${encodeURIComponent(ruleId)}`, {
    method: "DELETE",
		fetchImpl,
    signal,
  }, "Impossible de supprimer la règle Sollio.");
}
